module.exports = __webpack_public_path__ + "static/media/localhost_systema_pos_.e653a321.png";